import { err, ok, Result } from '@easeltv/fail';

import { ResponseParseFail } from '../errors';
import { NonValidatedResponse } from '../utils/types';

/**
 * parseResponse
 *
 * Converts response from fetch into JSON to be validated.
 *
 * @param response - fetch Response object
 */
export const parseResponse = async (
    response: Response,
): Promise<Result<NonValidatedResponse, ResponseParseFail>> => {
    try {
        // Get text response ready to be parsed
        const textResponse = await response.text();

        // Try to parse text into JSON, if text exists otherwise return an empty object
        const jsonResponse = textResponse ? JSON.parse(textResponse) : {};

        // Return NonValidatedResponse object
        return ok({
            body: jsonResponse,
            status: response.status,
        });
    } catch (error: unknown) {
        // If JSON.parse fails - return error object
        return err(
            new ResponseParseFail({
                name: 'Response Parse Error',
                description: 'Response could not be parsed into JSON',
                key: 'remote.parse.json',
                data: { error, response },
                status: response.status,
            }),
        );
    }
};

/**
 * parseXhrResponse
 *
 * Converts response from XHR request into JSON to be validated.
 *
 * @param response - fetch Response object
 */
export const parseXhrResponse = (
    response: XMLHttpRequest,
): Result<NonValidatedResponse, ResponseParseFail> => {
    try {
        // Get text response ready to be parsed
        const textResponse = response.responseText;

        // Try to parse text into JSON, if text exists otherwise return an empty object
        const jsonResponse = textResponse ? JSON.parse(textResponse) : {};

        // Return NonValidatedResponse object
        return ok({
            body: jsonResponse,
            status: response.status,
        });
    } catch (error: unknown) {
        // If JSON.parse fails - return error object
        return err(
            new ResponseParseFail({
                name: 'Response Parse Error',
                description: 'Response could not be parsed into JSON',
                key: 'remote.parse.xhr',
                data: { error, response },
                status: response.status,
            }),
        );
    }
};
